module.exports = __webpack_public_path__ + "static/media/Nota Fiesta Mexicana con especias McCormick.5bb572c4.jpg";